 import Tab from 'bootstrap/js/dist/tab';

  document.addEventListener("DOMContentLoaded", function() {
  
    // var firstTabEl = document.querySelector('#myTab div:last-child button');
    // if (firstTabEl !== null) {
    //     var firstTab = new Tab(firstTabEl)
    //     console.log(firstTabEl)
    //     console.log(new Tab)
    //     firstTab.show()
    // }
    // var tabEl = document.querySelector('button[data-bs-toggle="tab"]')

    // tabEl.addEventListener('shown.bs.tab', function (event) {
    //     event.target // newly activated tab
    //     event.relatedTarget // previous active tab
    // })

});
